/**
 * klubb-club-nav (D44) — home → club-collection redirect.
 *
 * When the member has a club and the "send members to their club page from the
 * front page" setting is on, the index template renders
 * data-klubb-home-redirect="true" on <html> and we replace() to that club's
 * catalog. Shopify can't do a true server redirect on the index template
 * without an app/edge worker, so this is a client-side guard (V1) — a brief
 * flash of the home page is possible before the redirect.
 *
 * Note: establishing the active club from a club-catalog URL (the no-cookie
 * direct-link case) is already handled by klubb-header-hydrate.js, which adopts
 * data-klubb-url-club only when no club is active yet (a deliberate "selection
 * is permanent" choice). This module does NOT silently switch an existing
 * selection on collection visits — switching stays an explicit picker action.
 *
 * Exports pure helpers for unit tests; auto-inits in the browser.
 */

export function clubCatalogHref(club) {
  if (!club) return null;
  const handle = club.catalog_collection_handle || ((club.slug || '') + '-katalog');
  return '/collections/' + handle;
}

// The URL to send the home page to, or null to stay put.
export function homeRedirectTarget(settingOn, activeClub) {
  if (!settingOn || !activeClub) return null;
  return clubCatalogHref(activeClub);
}

function init() {
  const klubb = (typeof window !== 'undefined') ? window.klubb : null;
  if (!klubb) return;
  const html = document.documentElement;

  // Home → club collection redirect. The setting + index-template gate are baked
  // into the data-klubb-home-redirect marker by Liquid, so the only client-side
  // condition left is "does the member have an active club".
  if (html.getAttribute('data-klubb-home-redirect') === 'true') {
    const target = homeRedirectTarget(true, klubb.activeClub);
    if (target && window.location && typeof window.location.replace === 'function') {
      window.location.replace(target);
    }
  }
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}
